module.exports = __webpack_public_path__ + "static/img/lottery_modal-1.5e69a1b.22aa746.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/live/lottery_modal-1.5e69a1b.png
// module id = cWzF
// module chunks = 56